import request from '@/utils/request'

export function updateInviteRewardCfg(data) {
  return request({
    url: 'api/v1/invite-reward/updateInviteRewardCfg',
    method: 'post',
    data: data
  })
}

export function getInviteRewardList(data) {
  return request({
    url: 'api/v1/invite-reward/getInviteRewardCfg',
    method: 'post',
    data: data
  })
}

export function updateInviteProcessRewardCfg(data) {
  return request({
    url: 'api/v1/invite-reward/updateInviteProcessRewardCfg',
    method: 'post',
    data: data
  })
}

export function getInviteProcessRewardList() {
  return request({
    url: 'api/v1/invite-reward/getInviteProcessRewardCfg',
    method: 'get'
  })
}

export function delInviteProcessReward(data) {
  return request({
    url: 'api/v1/invite-reward/delInviteProcessRewardCfg',
    method: 'delete',
    data: data
  })
}
